import React from 'react';
import { Col, Row } from 'antd';
import EditAsset from './edit-asset/edit-asset';

const SceneAssetEdit = () => {
  return (
    <Row className={'edit-scene'} gutter={[10, 15]}>
      <Col span={24}>
        <EditAsset />
      </Col>
    </Row>
  );
};

export default SceneAssetEdit;
